import { buildEffectiveSections } from './fieldLayout.js';
import { FORM_SECTIONS } from './formSchema.js';

const titleCaseCategory = (category) =>
  String(category || 'other')
    .split(/[_-]+/)
    .filter(Boolean)
    .map((word) => `${word.slice(0, 1).toUpperCase()}${word.slice(1)}`)
    .join(' ') || 'Other';

/**
 * Resolves approval-page attachment headings from the same effective schema IntakeForm
 * uses. Map#set deliberately makes the dedicated Attachments page's later engagement-letter
 * label win over the inline upload's label, preserving the existing heading by default.
 * Uploaded legacy categories that no longer have a layout field stay visible with a safe
 * title-cased fallback.
 */
export function attachmentCategoriesForApproval(attachmentLayout, attachments = []) {
  const categories = new Map();
  for (const section of buildEffectiveSections(FORM_SECTIONS, attachmentLayout)) {
    for (const field of section.fields) {
      if (field.type === 'attachments' && field.category) {
        categories.set(field.category, field.label || titleCaseCategory(field.category));
      }
    }
  }
  for (const attachment of attachments) {
    const category = attachment?.category || 'other';
    if (!categories.has(category)) categories.set(category, titleCaseCategory(category));
  }
  return [...categories.entries()];
}
